import script from "./LastCompletedTaskCell.vue?vue&type=script&setup=true&lang=js"
export * from "./LastCompletedTaskCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__